// extracted by mini-css-extract-plugin
export var WelcomeBar = "WelcomeBar-module--WelcomeBar--37gS4";
export var WelcomeBar__button = "WelcomeBar-module--WelcomeBar__button--2EFLt";
export var WelcomeBar__buttonIcon = "WelcomeBar-module--WelcomeBar__buttonIcon--2aR80";
export var WelcomeBar__buttonLabel = "WelcomeBar-module--WelcomeBar__buttonLabel--TN21B";